module.exports = __webpack_public_path__ + "static/media/Humor-op-socialmedia.8f10fe30.jpg";